import type { ReactNode } from 'react';
import { Card } from './Controls.tsx';

export function EmptyState({
    title,
    description,
    action,
}: {
    title: string;
    description?: string;
    action?: ReactNode;
}) {
    return (
        <Card padding="lg" className="flex flex-col items-center gap-3 text-center">
            <p className="font-display text-lg font-semibold">{title}</p>
            {description && <p className="max-w-md text-muted">{description}</p>}
            {action}
        </Card>
    );
}
